module.exports = __webpack_public_path__ + "img/Interactivity.b553e782.svg";